/* AFIQ deck ladder. Tiers come from window.AFIQ_DATA._meta.ladder, i.e. the shop metafield
   afiq.discount_ladder that the automatic discounts are built from. Shopify floors the discount
   PER UNIT, so all maths is in cents with Math.floor. */
window.AFIQ = window.AFIQ || {};
(function () {
  var D = window.AFIQ_DATA || {}, T = ((D._meta || {}).ladder || []).filter(function (t) { return t.pct > 0; });
  if (!T.length) T = [{min:2,pct:8},{min:3,pct:12},{min:4,pct:15},{min:10,pct:20}];
  T.sort(function (a, b) { return a.min - b.min; });
  var v1 = D.products && D.products.v1;
  AFIQ.DECK_CENTS = v1 ? v1.price : 4299;
  AFIQ.LADDER = T;
  AFIQ.tier = function (n) { return T.filter(function (t) { return n >= t.min; }).pop() || {min:1,pct:0}; };
  AFIQ.nextTier = function (n) { return T.filter(function (t) { return n < t.min; })[0] || null; };
  AFIQ.unitCents = function (n, base) { base = base == null ? AFIQ.DECK_CENTS : base; return base - Math.floor(base * AFIQ.tier(n).pct / 100); };
  AFIQ.$ = function (c) {
    var f = ((D._meta || {}).money_format) || '${{amount}}', v = (c / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/<[^>]*>/g, '');
  };
})();
